import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Account from '../../components/account/form';
import {
  ALERT_ACCOUNT_UPDATED,
  ALERT_RECOVER_PASSWORD_SENT,
  ALERT_UPDATE_ACCOUNT_ERROR,

  updateUser,
  showAlert,
  hideAlert,
  recoverUserPassword,
} from '../../actions';

class AccountContainer extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onResetPassword = this.onResetPassword.bind(this);
  }

  onSubmit(data) {
    this.hideAlerts();
    return this.props.actions.updateUser(this.props.user, data, this.props.authentication)
      .then(() => this.props.actions.showAlert(ALERT_ACCOUNT_UPDATED))
      .catch((error) => {
         const content = error.message;
         this.props.actions.showAlert(ALERT_UPDATE_ACCOUNT_ERROR, { content });
      });
  }

  onResetPassword(email) {
    this.hideAlerts();
    this.props.actions.recoverUserPassword(this.props.user, email)
      .then(() => this.props.actions.showAlert(ALERT_RECOVER_PASSWORD_SENT));
  }

  hideAlerts() {
    this.props.actions.hideAlert(ALERT_ACCOUNT_UPDATED);
    this.props.actions.hideAlert(ALERT_UPDATE_ACCOUNT_ERROR);
    this.props.actions.hideAlert(ALERT_RECOVER_PASSWORD_SENT);
  }

  render() {
    return (
      <Account
        user={this.props.user}
        onSubmit={this.onSubmit}
        onResetPasswordClick={this.onResetPassword}
        initialValues={this.props.initialValues}
        facebookAuthenticated={!!this.props.user.facebookUid}
      />
    );
  }
}

const mapStateToProps = ({ users, session }) => {
  const user = users.byId[users.current];
  return {
    user,
    authentication: session.authentication,
    initialValues: {
      fullName: user.fullName,
      email: user.email,
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      updateUser,
      showAlert,
      hideAlert,
      recoverUserPassword,
    }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/account/index.container.js